import { render } from "./RemoteImageEditor.vue?vue&type=template&id=4116e8a6&scoped=true"
import script from "./RemoteImageEditor.vue?vue&type=script&lang=ts"
export * from "./RemoteImageEditor.vue?vue&type=script&lang=ts"

import "./RemoteImageEditor.vue?vue&type=style&index=0&id=4116e8a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4116e8a6"

export default script